@if (loadingBrand) {
    <app-wait></app-wait>
}

@if (!loadingBrand) {
    <div class="login-left-side">
        <form [formGroup]="formData" [ngClass]="brandKey ? 'branded login' : 'login'"  autocomplete="OFF">
            <div class="login-panel-header">
                <div class="login-header-title">
                    @if (brandKey) {
                        <img src="/images/sircon-logo-white.svg" alt="Sircon, a Vertafore company"> |
                    }
                    Sign In
                </div>
            </div>

            <div class="login-info">
                <app-message-box [content]="errors"></app-message-box>

                @if (confirmingSso) {
                    <app-message-box level="info"
                                     prominent="Verify your Sircon account"
                                     [messages]="{message: 'Please sign in to verify your sircon account.'}"></app-message-box>
                }

                <app-input fieldId="subscriberId" label="Account ID" type="text" formControlName="accountId" [isDisabled]="freezeSubscriberId()"
                           autoFocus isRequired></app-input>

                <app-input fieldId="username" label="Username" formControlName="loginName"
                           isRequired></app-input>

                <app-input fieldId="password" label="Password" type="password" formControlName="password"
                           isRequired></app-input>

                <div class="forgot-password-link">
                    <button type="button" class="button-link" (click)="goToSignInHelpWorkflow()">Forgot password or lost access to your account ID? Get help signing in</button>
                </div>

                <div class="button-row">
                    <app-wait-button (onClick)="authenticate()" cssClass="btn btn-verty" [waiting]="submitting" label="Sign In"></app-wait-button>
                </div>
            </div>
        </form>

        <app-cx-hidden-login-form
            formId="submissionForm"
            [sirconUrl]="sirconUrl"
            [redirectRoute]="redirectRoute"
            [redirectParams]="redirectParams"
            [rememberMe]="cookieInUse"
            [submitRequest]="submitSignal()"
            (submissionError)="handleSubmissionError()">
        </app-cx-hidden-login-form>

        <div class="walkup-help">
            @if (carrierInformation) {
                <a target="_blank" href="{{brandedWalkupHelpUrl()}}">Sircon Help & Support</a>
            }
        </div>
    </div>
}

@if (brandKey) {
    <div class="brand-panel">
        <app-brand-information (loadingBrandEvent)="loadingBrandEvent($event)"
                               (carrierInformationEvent)="carrierInformationEvent($event)">
        </app-brand-information>
    </div>
}
